import { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import {
  Facebook,
  Instagram,
  Linkedin,
  Telegram,
  Twitter,
  Whatsapp,
  Copy,
} from '../../../../../media/images/shareModal/index.js'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import { useAuth } from '../../../auth'

export default function CreateLinkModal({ isActive, setIsActive, url, close }: any) {
  const { formatMessage } = useIntl()
  const link = url
  const [textToCopy, setTextToCopy] = useState(link)
  const { companyId, currentUser } = useAuth()
  useEffect(() => {
    setTextToCopy(url) // Update textToCopy whenever url changes
  }, [url])

  function handleCopy(event: any) {
    setTextToCopy(link)
    navigator.clipboard.writeText(link) // Update to use navigator.clipboard for modern browsers
    toast.success('Link copied to clipboard')
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.ShareSocialMedia,
        action: 'normal',
        metadata: {
          link: link,
          company_id: companyId,
          user_id: currentUser?.userId,
          email: currentUser?.email,
        },
      },
    })
    event.preventDefault()
  }

  function handleSocialShare(platform: string) {
    let message = ''
    let url = ''
    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(message + link)}`
        break
      case 'instagram':
        url = `https://www.instagram.com/sharer/sharer.php?u=${encodeURIComponent(message + link)}`
        break
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(message + link)}`
        break
      case 'linkedin':
        url = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(message + link)}`
        break
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message + link)}`
        break
      case 'telegram':
        url = `https://telegram.me/share/url?url=${encodeURIComponent(message + link)}`
        break
      default:
        return
    }
    window.open(url, '_blank')
  }

  return (
    <>
      <Modal
        show={isActive}
        backdrop="static"
      >
        <Form>
          <Modal.Header closeButton onHide={() => close()}>
            <h2>{formatMessage({ id: 'Your link has been created' })}</h2>
          </Modal.Header>
          <Modal.Body>
            <div className='link-share'>
              <p className='doc-link-label'>
                {formatMessage({
                  id: 'Copy and paste the link below into an email or wherever you want to send it',
                })}
              </p>
              <div className='d-flex justify-content-around align-items-center px-4 py-3 border border-black rounded-1'>
                <p className='doc-link'>{textToCopy}</p>
                <button className='copy-btn' onClick={handleCopy}>
                  <img src={Copy} alt='copy-btn' />
                </button>
              </div>
            </div>
            <div className='d-flex justify-content-center align-items-center my-2'>
              <button className='btn btn-primary d-flex align-items-center' onClick={handleCopy}>
                <img
                  src={Copy}
                  alt='copy-btn'
                  className='me-3'
                  style={{ filter: 'brightness(0) invert(1)' }}
                />
                <span className='fw-light'>{formatMessage({ id: 'Click to copy link' })}</span>
              </button>
            </div>
            <div className='mb-5 mt-8'>
              <h1 className='share-desc'>
                {formatMessage({ id: 'Easily share this file with others' })}
              </h1>
            </div>
            <div className='d-flex justify-content-center'>
              <button type='button' className='social-container' onClick={() => handleSocialShare('facebook')}>
                <img src={Facebook} alt='facebook-icon' />
              </button>
              <button type='button' className='social-container' onClick={() => handleSocialShare('instagram')}>
                <img src={Instagram} alt='instagram-icon' />
              </button>
              <button type='button' className='social-container' onClick={() => handleSocialShare('linkedin')}>
                <img src={Linkedin} alt='linkedin-icon' />
              </button>
              <button type='button' className='social-container' onClick={() => handleSocialShare('twitter')}>
                <img src={Twitter} alt='twitter-icon' />
              </button>
              <button type='button' className='social-container' onClick={() => handleSocialShare('whatsapp')}>
                <img src={Whatsapp} alt='whatsapp-icon' />
              </button>
              <button type='button' className='social-container' onClick={() => handleSocialShare('telegram')}>
                <img src={Telegram} alt='telegram-icon' />
              </button>
            </div>
          </Modal.Body>
        </Form>
      </Modal>
    </>
  )
}
